import { gql } from "@apollo/client";

const GET_VNPAY_ORDERS = gql`
  query vnpayOrders {
    vnpayOrders {
      id
      orderId
      orderType
      description
      amount
      status
      currencyCode
      locale
      createDate
      expireDate
    }
  }
`;

export default GET_VNPAY_ORDERS;
